// @ts-nocheck
import {addSeconds, format} from 'date-fns'
import {dateToUTC} from '@/utils/helpers'
import {flightSalesTermsRsTransformer, salesTermPackagesRsTransformer, setPriceFilter} from '@/utils/api-helpers'
import {filters} from '~src/utils/flights/flights-blank-states.src'
import {appInstance} from '@/utils/app-accessor'
import {addCustomFilters} from '~src/utils/flights/flight-transformers'

export default function (rs, inPackage = false) {
    // TODO [P1] Investigate solution how to import config
    const offersLifetime = import.meta.client ? appInstance.$conf.public.search.offersLifetime : 900

    //TODO need refactoring with searchAccommodation
    const expirationTime = format(dateToUTC(addSeconds(new Date(), offersLifetime)), 'yyyy-MM-dd HH:mm')
    const data = {
        offers: [],
        filters: filters(),
        searchKey: rs.searchKey,
        processed: rs.processed,
    }
    const addValueToFilter = (filter, value, groupName) => {
        value = String(value)
        const index = data.filters[filter].findIndex(el => el.value === value)
        if (index === -1) {
            data.filters[filter].push({
                value,
                groupName,
                count: 1,
            })
        } else {
            data.filters[filter][index].count++
        }
    }
    if (!rs.offers || !rs.offers.length) {
        return data
    }
    data.offers = rs.offers.map(
        ({
            cancelations,
            offerKey,
            unitKey,
            salesTerms,
            salesTermPackages,
            available,
            lastTicketingDate,
            itinerary,
            flightTariff,
            combined,
            corporatePolicyViolation,
            fareTypeForPassengers,
            corporatePolicy,
            fareOptions,
            supplierCode,
            supplierName,
            pricingSourceType,
            longConnectionTime,
            nightFlight,
            tipsAvailable,
            soldOut,
        }) => {
            if (!Array.isArray(itinerary)) {
                itinerary = [itinerary]
            }
            let offerBrandedFare
            const resultItinerary = itinerary.map(({duration, segments, routeName}) => {
                const resultSegments = segments.map(
                    ({
                        flightSegmentName,
                        marketingAirlineName,
                        duration,
                        mealCode,
                        rph,
                        baggageInfo,
                        departureAirportDescription,
                        arrivalAirportDescription,
                        aircraftCode,
                        stopLocations,
                        departureAirportCode,
                        arrivalAirportCode,
                        categoryClass,
                        flightNumber,
                        stopQuantity,
                        arrivalDate,
                        departureDate,
                        aircraftName,
                        brandedFareName,
                        marketingAirline,
                        operatingAirline,
                        categoryClasses,
                        fareDescriptions,
                    }) => {
                        if (!marketingAirlineName) {
                            marketingAirlineName = marketingAirline
                        }
                        if (marketingAirlineName) {
                            addValueToFilter('airline', marketingAirlineName)
                        } else {
                            addValueToFilter('airline', 'Airline is not indicated')
                        }
                        if (categoryClass && categoryClass.classType) {
                            addValueToFilter('class', categoryClass.classType)
                        }
                        if (categoryClasses && categoryClasses.length) {
                            categoryClasses.forEach(cls => {
                                addValueToFilter('class', cls.classType)
                            })
                        }
                        offerBrandedFare = brandedFareName || 'other'
                        return {
                            name: flightSegmentName,
                            marketingAirlineName,
                            duration,
                            mealCode,
                            rph,
                            baggageInfo,
                            departure: {
                                airportDescription: departureAirportDescription,
                                airportCode: departureAirportCode,
                                date: departureDate,
                            },
                            arrival: {
                                airportDescription: arrivalAirportDescription,
                                airportCode: arrivalAirportCode,
                                date: arrivalDate,
                            },
                            aircraft: {
                                code: aircraftCode,
                                name: aircraftName,
                            },
                            stops: {
                                locations: stopLocations,
                                quantity: stopQuantity,
                            },
                            class: categoryClass,
                            flightNumber,
                            marketingAirline,
                            operatingAirline,
                            brandedFareName,
                            categoryClasses,
                            fareDescriptions,
                        }
                    }
                )
                const stopsCount = resultSegments.length - 1
                addValueToFilter('stops', stopsCount)
                return {
                    segments: resultSegments,
                    routeName,
                    stopsCount,
                    duration,
                }
            })

            addValueToFilter('brandedFareName', offerBrandedFare)

            const sumDuration = resultItinerary.reduce((acc, itinerary) => acc + itinerary.duration, 0)
            if (sumDuration < data.filters.duration[0]) {
                data.filters.duration[0] = sumDuration
            }
            if (sumDuration > data.filters.duration[1]) {
                data.filters.duration[1] = sumDuration
            }
            const {price, supplierPrice, priceDetails, deltaPrice, notDeltaPrice} = !inPackage
                ? flightSalesTermsRsTransformer(salesTerms)
                : salesTermPackagesRsTransformer(salesTermPackages)
            if (!inPackage) {
                setPriceFilter(data.filters.price, price)
            } else if (deltaPrice) {
                setPriceFilter(data.filters.price, deltaPrice)
            }
            const refundable =
                fareTypeForPassengers &&
                fareTypeForPassengers.length &&
                fareTypeForPassengers[0].refundable !== 'undefined'
                    ? fareTypeForPassengers[0].refundable
                    : undefined
            if (refundable !== 'undefined') {
                // refundable = refundable ? 'refundable' : 'not_refundable'
                addValueToFilter('refundable', refundable)
            }
            if (supplierName) {
                addValueToFilter('supplierName', supplierName)
            }
            if (resultItinerary?.length) {
                resultItinerary.forEach(({segments}) => {
                    const segmentLength = segments.length
                    const counter = []

                    segments.forEach(({departure, arrival}, segmentIndex) => {
                        if (segmentIndex === 0) {
                            addValueToFilter(
                                'airport',
                                `${departure.airportDescription.airportName} (${departure.airportCode})`,
                                departure.airportDescription.cityName
                            )
                        } else if (segmentIndex === segmentLength - 1) {
                            addValueToFilter(
                                'airport',
                                `${arrival.airportDescription.airportName} (${arrival.airportCode})`,
                                arrival.airportDescription.cityName
                            )
                        }

                        if (segmentLength > 1) {
                            if (segmentIndex === 0) {
                                addValueToFilter(
                                    'transferAirport',
                                    `${arrival.airportDescription.airportName} (${arrival.airportCode})`
                                )
                                counter.push(arrival.airportCode)
                            } else if (
                                segmentIndex === segmentLength - 1 &&
                                counter.every(airportCode => airportCode !== departure.airportCode)
                            ) {
                                addValueToFilter(
                                    'transferAirport',
                                    `${departure.airportDescription.airportName} (${departure.airportCode})`
                                )
                                counter.push(departure.airportCode)
                            } else if (
                                segmentIndex !== segmentLength - 1 &&
                                counter.every(airportCode => airportCode !== arrival.airportCode)
                            ) {
                                addValueToFilter(
                                    'transferAirport',
                                    `${arrival.airportDescription.airportName} (${arrival.airportCode})`
                                )
                                counter.push(arrival.airportCode)
                            }
                        }
                    })

                    if (segments[0].baggageInfo && segments[0].baggageInfo?.length)
                        addValueToFilter(
                            'baggage',
                            segments[0].baggageInfo && segments[0].baggageInfo[0].baggage.unitQuantity >= 1
                                ? 'free_baggage'
                                : 'baggage_is_not_included'
                        )
                })
            }

            const offer = {
                itinerary: resultItinerary,
                cancelations,
                ...(price && {price}),
                ...(supplierPrice && {supplierPrice}),
                ...(deltaPrice && {deltaPrice}),
                ...(notDeltaPrice && {notDeltaPrice}),
                ...(priceDetails && {priceDetails}),
                offerKey,
                available,
                flightTariff,
                combined,
                lastTicketingDate,
                corporatePolicyViolation,
                corporatePolicy,
                refundable,
                sumDuration,
                fareOptions,
                supplierName,
                supplierCode,
                unitKey,
                regular: !supplierCode.includes('company.'),
                expirationTime,
                pricingSourceType,
                longConnectionTime,
                nightFlight,
                ...(tipsAvailable && {tipsAvailable}),
                ...(soldOut && {soldOut}),
            }

            addCustomFilters(addValueToFilter, offer, data.filters)

            return offer
        }
    )

    const notSortable = ['price', 'duration', 'startTime', 'endTime', 'flightNumber', 'loyaltyAmount']
    Object.keys(data.filters).forEach(key => {
        if (!notSortable.includes(key)) {
            switch (key) {
                case 'stops':
                    data.filters.stops.sort((a, b) => {
                        return a.value > b.value
                    })
                    break

                default:
                    if (data.filters[key].length) {
                        data.filters[key].sort((a, b) => {
                            return a.value.localeCompare(b.value)
                        })
                        data.filters[key] = moveOtherToEnd(data.filters[key])
                        break
                    }
            }
        }
    })

    return data
}

function moveOtherToEnd(data) {
    const index = data.findIndex(el => {
        return el.value === 'other' || el.value === 'Other'
    })
    if (index >= 0) {
        data.push(data.splice(index, 1)[0])
    }
    return data
}
